import { render, staticRenderFns } from "./PressNewForms.vue?vue&type=template&id=5e061de8&scoped=true"
import script from "./PressNewForms.vue?vue&type=script&lang=js"
export * from "./PressNewForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e061de8",
  null
  
)

export default component.exports